// UI에서 쓰는 대상/컨셉 라벨과 친밀도 단계 정의.
// 실제 프롬프트 생성 규칙/예시는 서버(api/_prompt.js)에만 두어 노출되지 않도록 한다.

const TARGETS = {
  boss:       { label: '직장 상사',   levels: ['편한 사이','보통 사이','어려운 편','매우 어려움'], guestOk: true },
  prof:       { label: '교수님',      levels: ['친근하신 편','보통','엄격하신 편','첫 연락'],     guestOk: false },
  client:     { label: '클라이언트',  levels: ['오래된 관계','보통','꼼꼼한 분','첫 만남'],      guestOk: false },
  crush:      { label: '썸남썸녀',    levels: ['첫만남','2번 만남','3번+ 만남','고백각'],        guestOk: false },
  blind_date: { label: '소개팅 상대', levels: ['마음에 듦','보통','마음에 안 듦',''],            guestOk: false },
};

const CONCEPTS = {
  mz:      { label: 'MZ어',   guestOk: true },
  pangyo:  { label: '판교어', guestOk: false },
  formal:  { label: '공문체', guestOk: false },
  dad:     { label: '아빠어', guestOk: false },
  cushion: { label: '쿠션어', guestOk: false },
};

export { TARGETS, CONCEPTS };
